import React, { createContext, useContext } from "react";
import {
  IDiscountKxm,
  IDiscountProductOffered,
} from "./DiscountProduct.interface";

export enum EDiscountProductType {
  KXM = "kxm",
  OFFERED = "offered",
}

export interface IDiscountProductNoticeBase {
  id: string;
  onClose?: () => void;
}

export interface IDiscountProductKxmNotice extends IDiscountProductNoticeBase {
  type: EDiscountProductType.KXM;
  discount: IDiscountKxm;
}

export interface IDiscountProductOfferedNotice
  extends IDiscountProductNoticeBase {
  type: EDiscountProductType.OFFERED;
  discount: IDiscountProductOffered;
}

export type IDiscountProductNotice =
  | IDiscountProductKxmNotice
  | IDiscountProductOfferedNotice;

interface IDiscountProductContextState {
  addNotice: (notice: IDiscountProductNotice) => void;
  removeNotice: (id: string) => void;
  notices: IDiscountProductNotice[];
  isLoading?: boolean;
  discountProductOffered?: IDiscountProductOffered[];
  kxm: {
    data?: IDiscountKxm[];
    isLoading: boolean;
    error?: unknown;
  };
}

const DiscountProductContext =
  createContext<IDiscountProductContextState>({
    addNotice: () => {},
    removeNotice: () => {},
    notices: [],
    isLoading: false,
    kxm: {
      data: [],
      isLoading: false,
      error: undefined,
    },
  });

export const useDiscountProductProvider = () => {
  const context = useContext(DiscountProductContext);

  return context || {};
};

export const useDiscountKxm = () => {
  const context = useContext(DiscountProductContext);
  return context.kxm;
};

export default DiscountProductContext;
